import React from 'react';
import { cn } from 'lib/utils';

export interface SettingsSectionHeaderProps {
  title: React.ReactNode;
  /** A quiet chip after the title, e.g. how many members the organization has. */
  count?: number;
  description?: React.ReactNode;
  /** The section's own action (e.g. invite), kept clear of the dialog's close button. */
  actions?: React.ReactNode;
  className?: string;
}

/** A settings section's heading: an 18px title, an optional count chip and a 13.5px line under it. */
export function SettingsSectionHeader({ title, count, description, actions, className }: SettingsSectionHeaderProps) {
  return (
    <div className={cn('flex items-start justify-between gap-4 md:pr-9', className)}>
      <div className="flex min-w-0 flex-col gap-1">
        <div className="flex min-w-0 items-center gap-2.5">
          <h2 className="truncate text-lg font-semibold leading-[22px] text-foreground">{title}</h2>
          {count != null && (
            <span className="inline-flex h-[22px] shrink-0 items-center rounded-md bg-muted px-2 text-xs tabular-nums text-muted-foreground">
              {count}
            </span>
          )}
        </div>
        {description && <p className="text-[13.5px] leading-[18px] text-muted-foreground">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}

export default SettingsSectionHeader;
